import { useEffect, useMemo, useRef, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { VForm, useVForm } from "../../shered/forms";
import {
    Autocomplete, CircularProgress,
    Box, Button, Icon,
    FormControl,
    InputLabel,
    MenuItem,
    Select, Tab, Tabs,
    Paper, Typography, useTheme,
    TextField,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Tooltip
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import clsx from 'clsx';
import { ptBR } from '@mui/x-data-grid/locales';
import { DataGrid, GridActionsCellItem, GridCellParams, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { AnosTemporadas, TDropOptions, UtilidadeService, lstDropDireitos, lstDropLance } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { SelectManyComponent } from "../../shered/components/select/SelectMany";
import {
    LeilaoService, IDadosContratacaoLeilao, IListaDadosLanceLeilao,
    IListagemHistoricoLance, IListagemSalarios,
    IListagemTimes, IDetalheJogadorLeilao, IListaDadosHistoricoLeilao, IListaDadosTodosLeilao
} from "../../shered/services/api/leilao/LeilaoService";
import { VTextMaskCustom } from "../../shered/forms/VTextMaskCustom";
import dayjs from 'dayjs'
import { AddTask } from "@mui/icons-material";
import { render } from "react-dom";
import moment from "moment";
//import { ContagemRegressiva } from "../../shered/components/contador/ContagemRegressiva";
//import moment from 'moment'

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: 1 }}>
                    <Grid container>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const lstPosicoes = ["PG", "SG", "SF", "PF", "C"];

const lstDropRodadas = [
    {
        codigo: 1,
        label: "1",
    },
    {
        codigo: 2,
        label: "2",
    },
    // {
    //     codigo: 3,
    //     label: "3",
    // },
    // {
    //     codigo: 4,
    //     label: "4",
    // }
];

const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

    let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
    //console.log(posicoes);
    let qtd = posicoes.split("|").length;
    let arrImagens = posicoes.split("|");

    let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={25} height={25} style={{ borderRadius: "50%" }} />
        : qtd === 2 ?
            <>  <img src={arrImagens[0]} alt={"img1"} width={25} height={25} style={{ borderRadius: "50%" }} />
                <img src={arrImagens[1]} alt={"img2"} width={25} height={25} style={{ borderRadius: "50%", marginLeft: 4 }} />
            </>
            : <> <img src={arrImagens[0]} alt={"img1"} width={25} height={25} style={{ borderRadius: "50%" }} />
                <img src={arrImagens[1]} alt={"img2"} width={25} height={25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                <img src={arrImagens[2]} alt={"img3"} width={25} height={25} style={{ borderRadius: "50%", marginLeft: 4 }} />
            </>

    return imgs
}

const columns: GridColDef[] = [
    {
        field: 'codigo',
        headerName: 'ID',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 90 : 190,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'rodada',
        headerName: UtilidadeService.isMobile() ? "ROD" : 'RODADA',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 60 : 190,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'foto_Jogador',
        headerName: 'FOTO',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 60 : 110,
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
            ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "../../../../semimagem.png";
                    currentTarget.style.borderRadius = "50%";
                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                }}
            />
            : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'nome_Jogador',
        headerName: 'JOGADOR',
        editable: false,
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 130 : 150,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'left',
        align: 'left',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'posicao_Jogador',
        headerName: 'POSIÇÃO',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 70 : 130,
        editable: false,
        sortable: UtilidadeService.isMobile() ? false : true,

        renderCell: (params) => carregaPosicao(params.row.posicao_Jogador, null, null),
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'nome_Franquia',
        headerName: 'DIREITO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 130 : 150,
        align: 'left',
        headerAlign: 'left',
        sortable: UtilidadeService.isMobile() ? false : true,
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'valor',
        headerName: 'VALOR',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        align: 'right',
        headerAlign: 'right',
        minWidth: UtilidadeService.isMobile() ? 110 : 130,
        sortable: UtilidadeService.isMobile() ? false : true,
        renderCell: (params) => moedaRealLocaleValue(params.value),
    },
    {
        field: 'dtCriacao',
        headerName: 'DATA',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        minWidth: UtilidadeService.isMobile() ? 110 : 130,
        sortable: UtilidadeService.isMobile() ? false : true,
        valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
    }
];

const columnsHistorico: GridColDef[] = [
    {
        field: 'codigo',
        headerName: 'ID',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 90 : 110,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'rodada',
        headerName: 'RODADA',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 90 : 110,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'foto_Jogador',
        headerName: 'FOTO',
        flex: 1,
        sortable: false,
        minWidth: UtilidadeService.isMobile() ? 70 : 110,
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
            ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "../../../../semimagem.png";
                    currentTarget.style.borderRadius = "50%";
                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                }}
            />
            : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
        align: 'center',
        headerAlign: 'center',
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'nome_Jogador',
        headerName: 'JOGADOR',
        editable: false,
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 100 : 150,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'left',
        align: 'left',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'nome_Franquia',
        headerName: 'DIREITO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 110 : 150,
        align: 'left',
        headerAlign: 'left',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'valor',
        headerName: 'VALOR',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 110 : 130,
        align: 'right',
        headerAlign: 'right',
        renderCell: (params) => moedaRealLocaleValue(params.value),
    },
    {
        field: 'data_Fim_Lance',
        headerName: 'DATA',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 110 : 130,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
    },
    {
        field: 'vencedor',
        headerName: 'VENCEDOR',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 110 : 130,
        sortable: UtilidadeService.isMobile() ? false : true,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value === true && params.row.irregular === false ? "Sim" : "Não",
    }
];

const columnsTimes: GridColDef[] = [
    { field: 'codigo', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header' },
    {
        field: 'nome',
        headerName: 'TIME',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
    },
    {
        field: 'cap',
        headerName: 'CAP',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }
            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) => `${moedaRealLocaleValue(params.row.cap) || ''}`,

    },
    {
        field: 'valor_Total_Lance',
        headerName: 'VALOR LANCE',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.valor_Total_Lance) || ''}`,

    },
    {
        field: 'cap_Disponivel',
        headerName: 'CAP FREE',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.cap_Disponivel) || ''}`,


    },
    {
        field: 'quantidade_Slot',
        headerName: 'SLOTS',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",

    },
    {
        field: 'quantidade_Lance',
        headerName: 'QTD. LANCE',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",
    },
    {
        field: 'quantidade_Slot_Disponivel',
        headerName: 'SLOT DISPONÍVEL',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",

    },
];

const columnsSalarios: GridColDef[] = [
    { field: 'codigo', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header' },
    {
        field: 'valor_Minimo',
        headerName: 'MÍNIMO VALOR',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },

        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.valor_Minimo) || ''}`,
    },
    {
        field: 'valor_Maximo',
        headerName: 'MÁXIMO VALOR',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        headerAlign: "right",
        align: "right",
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params.value == null) {
                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        valueGetter: (params: GridValueGetterParams) =>
            `${moedaRealLocaleValue(params.row.valor_Maximo) || ''}`,
    },
    {
        field: 'tempo_Minimo',
        headerName: 'MÍNIMO DURAÇÃO',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",
    },
    {
        field: 'tempo_Maximo',
        headerName: 'MÁXIMO DURAÇÃO',
        flex: 1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        align: "center",
        headerAlign: "center",
    }
];

export const DetalheDeLeilao: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    const { themeName } = useAppThemeContext();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const buttonRef = useRef(null);
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);

    const [redirecionar, setRedirecionar] = useState("");
    const [lstJogadores, setLstJogadores] = useState<TDropOptions[]>([]);
    const [jogadorSelecionado, setJogadorSelecionado] = useState<number>(0);
    const [valorSalarioJogador, setValorSalarioJogador] = useState<string>("");
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [anoSelecionado, setAnoSelecionado] = useState<number>(0);
    const [value, setValue] = useState(0);
    const [aberturaLeilao, setAberturaLeilao] = useState(false);
    const [showGridLeilao, setShowGridLeilao] = useState(false);

    const [posicao, setPosicao] = useState<number>(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [jogadoresRows, setJogadoresRows] = useState<IListagemJogador[]>([]);
    const [rowsSalarios, setRowsSalarios] = useState<IListagemSalarios[]>([]);
    const [codigoLeilao, setCodigoLeilao] = useState<number>(0);
    const [listaLanceLeilao, setListaLanceLeilao] = useState<IListaDadosLanceLeilao[]>([]);
    const [listaLanceLeilaoRestrito, setListaLanceLeilaoRestrito] = useState<IListaDadosLanceLeilao[]>([]);

    const [historicoRows, setHistoricoRows] = useState<IListaDadosHistoricoLeilao[]>([]);
    const [meusLancesRows, setMeusLancesRows] = useState<IListaDadosHistoricoLeilao[]>([]);
    const [meusLancesAtivosRows, setMeusLancesAtivosRows] = useState<IListaDadosHistoricoLeilao[]>([]);
    const [lstDadosTodosLances, setLstDadosTodosLances] = useState<IListaDadosTodosLeilao[]>([]);
    const [dataFimLance, setDataFimLance] = useState<any>();
    const [alterouData, setAlterouData] = useState<any>();
    const [tempoLance, setTempoLance] = useState<string>("");
    const [lanceDia, setLanceDia] = useState<number>(0);
    const [lanceHora, setLanceHora] = useState<number>(0);
    const [lanceMinuto, setLanceMinuto] = useState<number>(0);
    const [lanceSegundo, setLanceSegundo] = useState<number>(0);
    const [rodadaLeilao, setRodadaLeilao] = useState<number>(0);


    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""

    });


    useEffect(() => {

        //let codigoDecrpt = UtilidadeService.decrypt(codigoLiga !== null ? codigoLiga : "0");

        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        setIsLoading(true);
        setRemoveLoading(false);
        const fetchData = async () => {
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    //console.log(liga);
                    setDadosLiga(liga);
                    setAberturaLeilao(liga.abertura_Leilao);
                    setShowGridLeilao(liga.abertura_Leilao);
                    setCodigoLeilao(liga.codigo_Leilao);
                    setCodigoFranquia(liga.codigo_Franquia);
                    setRodadaLeilao(liga.rodada_Leilao !== undefined ? (liga.rodada_Leilao - 1) : 0);
                    if (liga.abertura_Leilao) {
                        CarregarMeusLeiloesAtivos(liga.codigo_Leilao, liga.codigo_Franquia, liga.rodada_Leilao);
                    }
                    CarregarMeusLeiloes(liga.codigo_Leilao, liga.codigo_Franquia, 0);
                    CarregarHistoricoLeilao(liga.codigo_Leilao, 0, liga.rodada_Leilao);
                    CarregarTodosDados(liga.codigo_Leilao, liga.rodada_Leilao);

                    //setRemoveLoading(true);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }

        fetchData();
        CarregarListaJogadores(null, null, null);

    }, [codigoLiga]);

    const CarregarTodosDados = async (codigoLeilao: number, rodadaAtual: number) => {
        await LeilaoService.getTodosPorCodigoLeilao(codigoLeilao)
            .then((result) => {
                setIsLoading(false);

                const todosDados = result.dado;
                setLstDadosTodosLances(todosDados.length > 0 && rodadaAtual > 1 ? todosDados.filter(f => f.rodada === (rodadaAtual - 1)) : []);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarMeusLeiloes = async (codigoLeilao: number, codigoFranquia: number, rodadaLeilao: number) => {

        await LeilaoService.getHistoricoLeilao(codigoLeilao, codigoFranquia, 0)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                const dadosMeusLeiloes = result.dado;
                setMeusLancesRows(dadosMeusLeiloes.length > 0 ? dadosMeusLeiloes : []);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarMeusLeiloesAtivos = async (codigoLeilao: number, codigoFranquia: number, rodadaLeilao: number) => {

        await LeilaoService.getMeusLeiloes(codigoLeilao, codigoFranquia, rodadaLeilao)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                const dadosMeusLeiloes = result.dado;
                setMeusLancesAtivosRows(dadosMeusLeiloes.length > 0 ? dadosMeusLeiloes : []);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }


    const CarregarHistoricoLeilao = async (codigoLeilao: number, codigoFranquia: number, rodadaLeilao: number) => {
        await LeilaoService.getHistoricoLeilao(codigoLeilao, codigoFranquia, rodadaLeilao)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                const dadosHistoricoLeilao = result.dado;

                setHistoricoRows(dadosHistoricoLeilao.length > 0 ? dadosHistoricoLeilao : []);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarListaJogadores = (posicao: string | null, direitos: string | null, lance: string | null) => {
        JogadorService.getAllPorLiga(Number(codigoLiga), 0, "")
            .then((result) => {
                setIsLoading(false);

                let resultado = result.data.dado;
                if (posicao !== null) {
                    resultado = result.data.dado.filter(i => (posicao.includes(i.posicao_1 !== null && i.posicao_1 !== "" ? i.posicao_1.toString().trim() : i.posicao_1)
                        || posicao.includes(i.posicao_2 !== null && i.posicao_2 !== "" ? i.posicao_2.toString().trim() : i.posicao_2)
                        || posicao.includes(i.posicao_3 !== null && i.posicao_3 !== "" ? i.posicao_3.toString().trim() : i.posicao_3)));
                }
                setJogadoresRows(resultado);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));

                setLstJogadores(lstDrop);
                setOpcoesAutoCompleteJogador(lstDrop);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleSave = async (dados: any) => {
        setIsLoading(true);
        const liga = dadosLiga !== null && dadosLiga !== undefined ? dadosLiga : null;
        if (liga === null) {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        if (selectedIdComplete === 0 || selectedIdComplete === undefined) {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar o jogador!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        if (valorSalarioJogador === "0" || valorSalarioJogador === undefined || valorSalarioJogador === "") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o valor do salário!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        const dadosSalvar: IDetalheJogadorLeilao = {
            codigo_Franquia: liga?.codigo_Franquia,
            codigo_Leilao: liga?.codigo_Leilao,
            codigo_Jogador: Number(selectedIdComplete),
            valor: valorSalarioJogador
        }

        LeilaoService.createJogadorLeilao(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Lance salvo com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("1");
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

            });
    }

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            // FranquiaService.deleteById(id)
            //     .then((result) => {
            //         setShowModalMensagem(true);
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "success",
            //             mensagem: "Registro excluido com sucesso!",
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //         setRedirecionar("/franquias");
            //     })
            //     .catch((errors) => {
            //         setShowModalMensagem(true);
            //         if (errors.response.data.statusHTTP === 401) {
            //             logout();
            //             setDadosModalMensagem({
            //                 acao: true,
            //                 label: "",
            //                 tipo: "error",
            //                 mensagem: "Sessão expirada!",
            //                 display: "none",
            //                 titulo: "Atenção"
            //             });
            //             setRedirecionar("0");;
            //             return;
            //         }
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "error",
            //             mensagem: errors.response.data.mensagem,
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //     });
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleNovoLance = () => {
        setShowGridLeilao(true);
    }

    const handleAcaoLeilao = (codigoLance: number) => {
        setShowModalEvent(true);
        let dadosLance = listaLanceLeilao.find(f => f.codigo === codigoLance);

        setDadosModalEvent({
            acao: true,
            label: "Aumentar",
            tipo: "info",
            mensagem: `Deseja aumentar a oferta do leilão? `,
            display: "none",
            titulo: "Leilão Free Agency",
            evento: "lanceLeilao",
            info: {
                dadosLance: dadosLance,
                codigoFranquia: codigoFranquia,
                style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
            }
        });

        // if (tipoAcao === "aceite") {
        //     setDadosModalEvent({
        //         acao: true,
        //         label: "Aceitar",
        //         tipo: "success",
        //         mensagem: `Deseja aceitar a oferta do leilão `,
        //         display: "none",
        //         titulo: "Atenção",
        //         evento: "aceiteLeilao",
        //         info: {
        //             codigoFranquia: codigoFranquia,
        //             codigoLeilao: codigoLeilao,
        //             codigoLiga: codigoLiga,
        //             style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
        //         }
        //     });
        // }
        // else if (tipoAcao === "rejeicao") {
        //     setDadosModalEvent({
        //         acao: true,
        //         label: "Aceitar",
        //         tipo: "warning",
        //         mensagem: `Deseja recusar a oferta do leilão `,
        //         display: "none",
        //         titulo: "Atenção",
        //         evento: "rejeicaoLeilao",
        //         info: {
        //             codigoFranquia: codigoFranquia,
        //             codigoLeilao: codigoLeilao,
        //             codigoLiga: codigoLiga,
        //             style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
        //         }
        //     });
        // }
        // else {

        //     setDadosModalEvent({
        //         acao: true,
        //         label: "Aceitar",
        //         tipo: "info",
        //         mensagem: `Deseja enviar contra proposta da oferta do leilão `,
        //         display: "none",
        //         titulo: "Atenção",
        //         evento: "contraPropostaLeilao",
        //         info: {
        //             codigoFranquia: codigoFranquia,
        //             codigoLeilao: codigoLeilao,
        //             codigoLiga: codigoLiga,
        //             // valor: novoValor,                   
        //             style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
        //         }
        //     });
        // }

    }

    const handleFiltrarJogadores = () => {
        let lstCodigosJogadoresFranquia: number[] = [];

    }

    return (
        <LayoutBaseDePagina
            titulo={`Leilão - ${dadosLiga?.nome}`}
            showLogoImg={dadosLiga?.caminho_Logo !== undefined ? dadosLiga?.caminho_Logo : showImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmApagar={() => handleDelete(Number(codigoFranquia))}
                    aoClicarEmNovo={() => navigate("/leilao/detalhe/nova")}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid container display="initial" alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} onChange={handleChangeTabs}>
                                        <Tab label="Lance" {...a11yProps(0)} />
                                        <Tab label="Meus Lances" {...a11yProps(1)} />
                                        <Tab label="Histórico"  {...a11yProps(2)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    {aberturaLeilao ? (
                                        <Grid size={{ xs: 12, sm: 12 }} container >
                                            {showGridLeilao && (
                                                <Grid container  size={{ xs: 12, sm: 12 }} spacing={1} paddingBottom={3}>
                                                    <Grid container size={{ xs: 12, sm: 12 }}  >
                                                        <Grid size={{ xs: 12, sm: 12 }} display="flex" textAlign="initial" >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Leilão</Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12 }}  >
                                                            <hr />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" spacing={1}  >
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                            <Autocomplete
                                                                openText="Abrir"
                                                                closeText="Fechar"
                                                                noOptionsText="Sem opções"
                                                                loadingText="Carregando..."
                                                                disablePortal
                                                                options={opcoesAutoCompleteJogador}
                                                                loading={isLoading}
                                                                disabled={isLoading}
                                                                value={autoCompleteSelectedOption}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                                                                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Jogador"
                                                                        slotProps={{                                                                           
                                                                            inputLabel: {
                                                                                shrink: edicao ? true : undefined,
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                            <VTextMaskCustom
                                                                fullWidth
                                                                name="selecaoJogador"
                                                                disabled={isLoading}
                                                                label="Valor"
                                                                type="text"
                                                                typeMask="currency"
                                                                value={valorSalarioJogador}
                                                                onChange={e => setValorSalarioJogador(e.target.value)}
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 6, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="error"
                                                                variant="outlined"
                                                                disableElevation
                                                                onClick={() => setShowGridLeilao(false)}
                                                                startIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14 }}>cancel</Icon>}
                                                                disabled={isLoading}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14, height: UtilidadeService.isMobile() ? 30 : "auto" }}
                                                            >
                                                                <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                    Cancelar
                                                                </Typography>
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 6, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={handleSave}
                                                                endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14 }}>add</Icon>}
                                                                disabled={isLoading}
                                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14, height: UtilidadeService.isMobile() ? 30 : "auto" }}
                                                            >
                                                                Salvar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} >
                                                        {meusLancesAtivosRows.length > 0 && (
                                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" >
                                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Lances</Typography>
                                                                    <hr />
                                                                    {!removeLoading && <Loading />}
                                                                </Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto"  >
                                                                    <Box sx={{
                                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                        '& .super-app-theme--header': {
                                                                            backgroundColor: theme.palette.common.black,
                                                                            color: theme.palette.common.white
                                                                        },
                                                                        '& .super-app.negative': {
                                                                            color: 'red',
                                                                            fontWeight: 'bold'
                                                                        },
                                                                        '& .super-app.positive': {
                                                                            color: themeName === "light" ? "black" : "auto",
                                                                        },
                                                                    }}>
                                                                        <DataGrid
                                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                            autoHeight
                                                                            getRowId={(rows) => rows.codigo}
                                                                            rows={meusLancesAtivosRows}
                                                                            columns={columns}
                                                                            columnVisibilityModel={{
                                                                                codigo: false
                                                                            }}
                                                                            initialState={{
                                                                                pagination: {
                                                                                    paginationModel: {
                                                                                        pageSize: 12,
                                                                                    },
                                                                                },
                                                                            }}
                                                                            pageSizeOptions={[12, 24, 50]}
                                                                            disableRowSelectionOnClick={UtilidadeService.isMobile() ? true : false}
                                                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                            hideFooter={true}
                                                                            sx={{
                                                                                fontSize: UtilidadeService.isMobile() ? 10 : "auto",
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    {lstDadosTodosLances.length > 0 &&
                                                        <>
                                                            <Grid container size={{ xs: 12, sm: 12 }}  >
                                                                <Grid size={{ xs: 12, sm: 12 }} display="flex" textAlign="initial" >
                                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Resultado rodada {rodadaLeilao}</Typography>
                                                                </Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }}  >
                                                                    {!removeLoading && <Loading />}
                                                                    <hr />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }}  spacing={2} sx={{ backgroundColor: "#494949", margin: "10px", padding: "18px" }}>
                                                                {lstDadosTodosLances.map((r, i) => (
                                                                    <Grid key={`Grid ${r.codigo}`} size={{ xs: 12, sm: 12, md: 12 }} paddingLeft={1} paddingRight={1} >
                                                                        <Card key={"Card" + i} >
                                                                            {/* <CardActionArea> */}
                                                                            <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" direction="row" alignSelf="center">
                                                                                    <Grid container size={{ xs: 12, sm: 3, md: 3 }} display="flex" alignSelf="center">
                                                                                        <Grid container display="flex" direction="column" size={{ xs: 12, sm: 12 }} justifyContent="center" >
                                                                                            <Grid size={{ xs: 12, sm: 12 }} display="flex" padding={1} >
                                                                                                <img src={r.foto === null ? showImagemFranquia : r.foto}
                                                                                                    alt={r.nome}
                                                                                                    width={UtilidadeService.isMobile() ? 45 : 70}
                                                                                                    height={UtilidadeService.isMobile() ? 45 : 70}
                                                                                                />
                                                                                                <Grid display="flex" alignSelf="end" paddingLeft={1} size={{ xs: 12, sm: 4 }} >
                                                                                                    {carregaPosicao(r.posicao, null, null)}
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                            <Grid display="flex" alignSelf="start" size={{ xs: 12, sm:6}} >
                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }} >
                                                                                                    <span style={{ fontWeight: "bold" }}>{r.nome} </span>
                                                                                                </Typography>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid display="flex" size={{ xs: 12, sm: 9, md: 9 }} flexDirection="row" justifySelf="start"  >
                                                                                        <Box width="100%" minHeight="80px" display="flex" alignSelf="center" >
                                                                                            <Grid container paddingRight={3} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" justifyItems="start" >
                                                                                                <Grid paddingLeft={1} display="flex" flexDirection="column" size={{ xs: 12, sm: 12 }}>
                                                                                                    {r.lance.sort((a, b) => a.data > b.data ? 1 : -1)
                                                                                                        .sort((a, b) => a.valor < b.valor ? 1 : -1)
                                                                                                        .map(p => (
                                                                                                            <Grid paddingLeft={1} size={{ xs: 12, sm: 12 }} display="flex" flexDirection="row" >
                                                                                                                <Grid display="flex" size={{ xs: 12, sm: 4 }} alignSelf="center">
                                                                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }} sx={{ color: p.irregular ? "#d93d9b" : p.vencedor ? "#03a835" : p.codigo_Franquia === codigoFranquia ? "#1d8cd1" : "auto" }} >
                                                                                                                        {` ${p.nome_Franquia}  `}
                                                                                                                    </Typography>
                                                                                                                </Grid >
                                                                                                                <Grid display="flex" size={{ xs: 12, sm: 4 }} alignSelf="center">
                                                                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }} sx={{ color: p.irregular ? "#d93d9b" : p.vencedor ? "#03a835" : p.codigo_Franquia === codigoFranquia ? "#1d8cd1" : "auto" }}>
                                                                                                                        {` R$ ${moedaRealLocaleValue(p.valor)} `}
                                                                                                                    </Typography>
                                                                                                                </Grid >
                                                                                                                <Grid display="flex" size={{ xs: 12, sm: 4 }} alignSelf="center">
                                                                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }} sx={{ color: p.irregular ? "#d93d9b" : p.vencedor ? "#03a835" : p.codigo_Franquia === codigoFranquia ? "#1d8cd1" : "auto" }}>
                                                                                                                        {` ${dayjs(p.data).format('DD/MM/YYYY HH:mm')}`}
                                                                                                                    </Typography>
                                                                                                                </Grid >
                                                                                                            </Grid>
                                                                                                        ))}
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Box>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                            {/* </CardActionArea> */}
                                                                        </Card>
                                                                    </Grid>
                                                                ))}
                                                            </Grid>
                                                        </>
                                                    }
                                                </Grid>
                                            )}
                                        </Grid>
                                    )
                                        : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Leilão fechado!</Typography>
                                            <hr />
                                        </Grid>
                                    }
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {!removeLoading && <Loading />}
                                    <Grid container  size={{ xs: 12, sm: 12 }}>
                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} >
                                            <Box sx={{
                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                '& .super-app-theme--header': {
                                                    backgroundColor: theme.palette.common.black,
                                                    color: theme.palette.common.white
                                                },
                                                '& .super-app.negative': {
                                                    color: 'red',
                                                    fontWeight: 'bold'
                                                },
                                                '& .super-app.positive': {
                                                    color: themeName === "light" ? "black" : "auto",
                                                },
                                            }}>
                                                <DataGrid
                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                    autoHeight
                                                    getRowId={(rows) => rows.codigo}
                                                    rows={meusLancesRows}
                                                    columns={columns}
                                                    columnVisibilityModel={{
                                                        codigo: false
                                                    }}
                                                    initialState={{
                                                        pagination: {
                                                            paginationModel: {
                                                                pageSize: 25,
                                                                //page: pagina,
                                                            },
                                                        },
                                                    }}
                                                    pageSizeOptions={[25, 50, 100]}
                                                    //checkboxSelection
                                                    disableRowSelectionOnClick={UtilidadeService.isMobile() ? true : false}
                                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                    hideFooter={true}
                                                    sx={{
                                                        fontSize: UtilidadeService.isMobile() ? 10 : "auto",
                                                    }}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    {!removeLoading && <Loading />}
                                    <Grid container height="auto"  size={{ xs: 12, sm: 12 }}>
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            },
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                getRowId={(rowsTimes) => rowsTimes.codigo}
                                                rows={historicoRows}
                                                columns={columnsHistorico}
                                                columnVisibilityModel={{
                                                    codigo: false
                                                }}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 25,
                                                            //page: pagina,
                                                        },
                                                    },
                                                }}
                                                pageSizeOptions={[25, 50, 100]}
                                                autoHeight
                                                disableRowSelectionOnClick
                                                disableColumnFilter
                                                disableColumnMenu
                                                hideFooter={true}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : "auto",
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid >
                </Box >
            </VForm >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
};


